import type { RAFile } from '@domain/types';
import {
    ResourceCategory,
    ResourceId,
    uploadResourceWithMetadata,
} from '@wwf/sdk';

export async function uploadRaFile(
    file: RAFile | null | undefined,
    category: ResourceCategory
): Promise<ResourceId | string | null> {
    if (!file) return null;
    if (file.rawFile instanceof File) {
        const resource = await uploadResourceWithMetadata(
            file.rawFile,
            category
        );
        return resource.id;
    }
    if (typeof file.src === 'string' && !file.src.startsWith('blob:')) {
        return file.src;
    }
    return null;
}
